/**
 * @module interface
 */
export interface V2TimLocationElem {
    desc?: string;
    longitude: number;
    latitude: number;
}
